<template>
  <div class="TemplateDownload">
    <div class="TitleTop">
      模板下载
    </div>
    <div class="DownloadList">
      <a >经销商信息表.docx</a>
      <a>业务员授权书.docx</a>
      <a>承诺函.docx</a>
      <a>关联申明.docx</a>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.TemplateDownload {
  // margin-top: 50px;
  .TitleTop {
    width: 100%;
    height: 45px;
    line-height: 45px;
    // border: 1px solid rebeccapurple;
    border-bottom: 1px solid #eaecef;
    font-size: 16px;
    font-weight: 500;
    color: #16181a;
  }

  .DownloadList {
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #eaecef;
    display: flex;
    justify-content: space-between;
    line-height: 80px;

    a {
      display: inline-block;
      font-size: 16px;
      border-bottom: 2px solid #00266d;
      height: 52px;
      font-weight: normal;
      color: #00266d;
      cursor: pointer;
      

    }
  }
}
</style>